import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../queryKeys';

import { createChannelCollectionQueryOptions } from './queryOptions';
import { ChannelsSettings } from './settings';

type UseChannelCollectionProps = {
  settings?: ChannelsSettings;
};

export type QuerySettings = Omit<ChannelsSettings, 'collectionId'> & { collectionId: number };

export function useChannelCollection({ settings }: UseChannelCollectionProps) {
  const isEnabled = Boolean(settings?.collectionId);

  const { data, isLoading, error, refetch } = useQuery({
    ...(isEnabled ? createChannelCollectionQueryOptions(settings as QuerySettings) : { queryKey: queryKeys.disabled }),
    enabled: isEnabled,
  });

  return {
    channelCollection: data?.collection,
    isLoading,
    error,
    refetch,
  };
}
